"use client";
import classes from "./Marquee.module.scss";
import React from "react";
import { useRef, useState, useEffect } from "react";

type Props = {
  showBreakingNews?: boolean;
  content: any;
  slug: any;
};

function Marquee(props: Props) {
  const { showBreakingNews = true, content, slug } = props;
  
  const contentRef = useRef<any>(null);
  const [contentWidth, setContentWidth] = useState(0);

  useEffect(() => {
    if (contentRef.current) {
      setContentWidth(contentRef.current.scrollWidth);
    }
  }, [content]);

  if (!content) return null;

  const openInNewTab = (slug: string) => {
    const url = `/article/${slug}`;
    window.open(url, "_blank");
    console.log("🚀 ~ openInNewTab ~ slug:", slug)
  };

  return (
    <div className={classes.container}>
      {showBreakingNews && (
        <div className={classes["breaking-news"]}>Breaking News</div>
      )}

      <div className={classes["scroll-container"]}>
        <div
          className={classes["scroll"]}
          style={
            { "--content-width": `${contentWidth}px` } as React.CSSProperties
          }
          onClick={() => openInNewTab(slug)}
        >
          {content}
        </div>

        <div ref={contentRef} className={classes["scroll-hide"]}>
          {content}
        </div>
      </div>
    </div>
  );
}

export default Marquee;
